import Vue from 'vue'
import Router from 'vue-router'
import routeList from './routeList'
import { login } from '../lib/utils'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: routeList
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    login()
      .then(() => {
        next()
      })
      .catch((err) => {
        console.log(err)
      })
  } else {
    next()
  }
})

export default router
